module.exports = "/src/views/player/oressale/assets/images/mushroom_gold.png";